(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/prescript.js');
'use strict';

var svs = svs || {};

svs.components = svs.components || {};
svs.components.youtube_video = svs.components.youtube_video || {};


 })(window);